export default {"src":"/_next/static/media/social-icon.e5925d62.svg","height":137,"width":137,"blurWidth":0,"blurHeight":0};